// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"profile-main_formContainer__2lF63","buttonContainer":"profile-main_buttonContainer__1XP15","tabsContainer":"profile-main_tabsContainer__1cASA"};